<template>
  <div class="sign_in_box">
    <div class="box">
      <img src="/static/index/index17.png" alt="">
      <div>
        <div class="b1">
          <div class="b11">忘记密码</div>
          <div></div>
        </div>
        <div class="b2">请填写账号信息</div>
        <div class="b3"><el-input v-model="input" type="number" placeholder="请输入手机号码"></el-input></div>
        <div class="b3"><el-input v-model="input" type="password" placeholder="请输入密码"></el-input></div>
        <div class="b3"><el-input v-model="input" type="password" placeholder="请确认密码"></el-input></div>
        <div class="b3"><el-input v-model="input" placeholder="请输入短信验证码"></el-input><div class="b31">获取验证码</div></div>
        <div class="b4">
          <el-button type="primary">保存并登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Cookie from 'js-cookie'
export default {
  props: [],
  components: {
  },
  data() {

    return {
      checked:false,
      input:'',
      type:1
    };
  },
  methods: {
    ...mapActions([]),
    submitForm() {
      
    }
  }
};
</script>
<style lang="scss" scoped>
.sign_in_box{
  width: 100%;
  // height: 100%;
  background: #FFFFFF;
  // overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
  .box{
    width: 1200px;
    margin: 0 auto;
    // padding: 0 23px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &>img{
      width: 639px;
      height: 566px;
    }
    &>div{
      width: 522px;
      .b1{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 43px;
        div{
          width: 45%;
          text-align: left;
          font-size: 40px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #999999;
        }
        .b11{
          font-weight: bold;
          color: #333333;
        }
      }
      .b2{
        font-size: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 600;
        color: #333333;
        margin-bottom: 26px;
      }
      .b3{
        width: 522px;
        height: 53px;
        border-radius: 4px;
        border: 1px solid #CCCCCC;
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .el-input{
          width: 95%;
          /deep/ .el-input__inner{
          background: transparent;
          border: none;
          
          &::placeholder {
            font-size: 18px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: #999999;
          }
        }
        }
        .b31{
          font-size: 18px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #FF5602;
          position: absolute;
          right: 20px;
          top: 15px;
          z-index: 99;
        }
        
      }
      .b4{
        margin-top: 40px;
        .el-button{
          padding: 16px 46px;
          background: #198AFA;
          margin-right: 20px;
        }
      }
      .b5{
        font-size: 18px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999; 
        margin-bottom: 27px;
        span{
          color: #198AFA;
        }
      }
      .b6{
        width: 510px;
        height: 1px;
        background: #cccccc46;
        margin: 20px auto;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/updatePassword/index.vue